/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState} from 'react';
import { Helmet } from 'react-helmet-async';

import PropTypes from 'prop-types';

// @mui
import { Container, Typography } from '@mui/material';

// components
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import PropaneTankIcon from '@mui/icons-material/PropaneTank';
import SellIcon from '@mui/icons-material/Sell';

import AllOrders from '../components/logistics/allOrders';
import SellModal from '../components/logistics/modals/sellModal';
import BuyModal from '../components/logistics/modals/buyModal';
import ApprovedOrders from '../components/logistics/approvedOrders';
import DeliveredOrders from '../components/logistics/delivered';
import DeclinedOrders from '../components/logistics/declinedOrders';
import AggregatedStatsComponent from '../components/logistics/aggregatedStatesComponent';
import AllocatedOrders from '../components/logistics/allocatedOrders';
import { useAlert } from '../contexts/LogisticsContext';
import GlobalFilter from '../components/ui/GlobalFilter';
import { isAuthorizedRole } from '../utils/authUtil';
import InvoiceList from '../components/ui/InvoiceList';
import { TabContext, TabList } from '@mui/lab';
import DepotPricingModal from '../components/logistics/modals/DepotPricingModal';
import BulkDepotPricingModal from '../components/logistics/modals/BulkDepotPricingModal';
import UnallocatedOrder from '../components/logistics/UnallocatedOrder';
import TechnicalDifficulties from '../components/logistics/TechnicalDifficulties';
import TransportCompany from '../components/logistics/modals/TransportCompany';
import CompanyVehicle from '../components/logistics/modals/CompanyVehicle';
import CompanyTrailer from '../components/logistics/modals/CompanyTrailer';
import CompanyDriver from '../components/logistics/modals/CompanyDriver';
import InterDepotTankTransfer from '../components/logistics/modals/InterDepotTankTransfer';
import API from '../data/api';
import WeeklySalesReport from 'src/components/logistics/modals/WeeklySalesReport';
import { NewProductLine } from 'src/components/logistics/modals/NewProductLine';
import CustomActionButton from 'src/components/custom/CustomActionButton';
import { useSnackbar } from 'src/contexts/SnackbarContext';
import { downloadApiFile } from 'src/utils/fileUtils';

// ----------------------------------------------------------------------
function CustomTabPanel(props) {
  const { children, value, selected, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== selected}
      id={`simple-tabpanel-${value}`}
      aria-labelledby={`simple-tab-${value}`}
      {...other}
    >
      {value === selected && (
        <Box >
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

/*
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
*/

const findDefaultTab = () => {
  let _tab = 0;
  if (isAuthorizedRole(["FINANCE-C2"])) {
    _tab = 6;
  }
  else if (isAuthorizedRole(["CUSTOMS-L1"])) {
    _tab = 1;
  }
  // else if (isAuthorizedRole(["FINANCE-L1"])){
  //   _tab = 5;
  // }

  return _tab;
};

export default function LogisticsPage() {

  const initialized = useRef(false);
  const { showSnackbar } = useSnackbar();

  // Check last selected tab or default to the first order tab
  const defaultTab = findDefaultTab();
  const selectedTab = Number(localStorage.getItem('logistics-tab') || defaultTab);

  const [transportCompanies, setTransportCompanies] = useState([]);
  const [value, setValue] = React.useState(selectedTab);
  const [filterString, setFilterString] = React.useState('');
  const [updateAllOders, setUpdateAllOders] =  React.useState(false)
  const [orderLimits, setOrderLimits] = useState({
    volume: {
      min: 1,
      max: 9999999999,
    }
  })
  const [modalState, setModalState] = useState({
    sell: false,
    buy: false,
    price: false,
    bulkPrice: false,
    transporter: false,
    vehicle: false,
    trailer: false,
    driver: false,
    intransfer: false,
    salesReport: false,
    product: false,
  })

  const { updateStats, setUpdateStats } = useAlert();
  const THIRTY_THOUSAND = 30000;

   useEffect(() => {

    setOrderLimits({
      ...orderLimits,
      volume: {
        min: isAuthorizedRole(["EXECUTIVE-C1", "OPERATIONS-C2"])? (THIRTY_THOUSAND + 1): 1,
        max: !isAuthorizedRole(["EXECUTIVE-C1", "OPERATIONS-C2", "DEMO"])? THIRTY_THOUSAND: 9999999999,
      }
    });

    if (!initialized.current && isAuthorizedRole(["CUSTOMS-L1", "DEMO"])) {
      getTransportCompanies();
    }
  }, [initialized.current,]);

  const getTransportCompanies = async () => {
    try {
      const response = await API.get(`inventory/backoffice/logistics`);
      if (response.status === 200) {
        setTransportCompanies(response.data?.clients || []);
        initialized.current = true;
      } else {
        console.error('Error fetching transport companies: ', response.status);
      }
    } catch (error) {
      console.error('Error fetching transport companies: ', error);
    }
  };

  const getApprovedTabLabel = () => {
    let label = 'Approved';
    if (isAuthorizedRole(["CUSTOMS-L1"])){
      label = 'Orders';
    } else if (isAuthorizedRole(["LOGISTICS-C2"])) {
      label = 'Bulk Break';
    }

    return label;
  }

  const handleChange = (event, newValue) => {
    setUpdateStats(true);
    setValue(newValue);
    localStorage.setItem('logistics-tab', newValue);
  };

  const handleFilterChange = (filter) => {
    setFilterString(filter);
    // localStorage.setItem('logistics-filters', filter)
  };

  const toggleModalState = (name, openState) => {
    setModalState({[name]: openState})
  };

  const getFilterString =() =>{
    return filterString || localStorage.getItem('logistics-filters') || '';
  }

  return (
    <>
      <Helmet>
        <title> Logistics</title>
      </Helmet>

      <Container maxWidth="false">
        <Box
          sx={{ display: 'flex', borderRadius: 1, marginTop: 2, mb: 3 }}
        >
          <Box sx={{ width: '100%' }}>
            <Typography variant="h4">
              Logistics
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexShrink: 0, mr: 2 }}>
            {(isAuthorizedRole(["SALES-C2"])) && (
              <>
                <CustomActionButton
                  hint="Download Weekly Sales Report Template"
                  handleOnClick={(e) => { downloadApiFile('analytics/sales/weekly_report', "weekly-sales-report-template.xlsx") }}
                  icon={<FileDownloadIcon />}
                  label={"Report Template"}
                />
                <CustomActionButton
                  hint="Upload Weekly Sales Report"
                  handleOnClick={(e) => { toggleModalState('salesReport', true) }}
                  icon={<FileUploadIcon />}
                  label={"Weekly Report"}
                />
                <WeeklySalesReport
                  openModal={modalState.salesReport}
                  handleCloseModal={() => toggleModalState('salesReport', false)}
                  handleSubmitCallback={() => toggleModalState('salesReport', false)}
                />
              </>
            )}
            {(value === 0 && isAuthorizedRole(["EXECUTIVE-C1", "OPERATIONS-C2", "DEMO"])) && (
              <>
                <CustomActionButton
                  hint="Create Supplier Order"
                  handleOnClick={(e) => { toggleModalState('buy', true) }}
                  icon={<AccountBalanceWalletIcon />}
                  label={"Buy Order"}
                />
                <BuyModal
                  openModal={modalState.buy}
                  toggleModalState={toggleModalState}
                  setUpdateStats={setUpdateStats}
                  setUpdateAllOders={setUpdateAllOders}
                  orderLimits={orderLimits}
                  showSnackbar={showSnackbar}
                />
              </>
            )}
            {(value === 0 && isAuthorizedRole(["EXECUTIVE-C1", "OPERATIONS-C2", "LOGISTICS-C2", "DEMO", "SALES-C2", "CUSTOMS-L1"])) && (
              <>
                <CustomActionButton
                  hint="Create Client Order"
                  handleOnClick={(e) => { toggleModalState('sell', true) }}
                  icon={<SellIcon />}
                  label={"Sell Order"}
                />
                <SellModal
                  openModal={modalState.sell}
                  toggleModalState={toggleModalState}
                  setUpdateStats={setUpdateStats}
                  setUpdateAllOders={setUpdateAllOders}
                  orderLimits={orderLimits}
                  showSnackbar={showSnackbar}
                />
              </>
            )}
            {(isAuthorizedRole(["FINANCE-C2", "DEMO"])) && (
              <>
                <CustomActionButton
                  hint="Set Depot Pricing"
                  handleOnClick={(e) => { toggleModalState('price', true) }}
                  icon={<AccountBalanceWalletIcon />}
                  label={"Depot Pricing"}
                />
                <DepotPricingModal
                  openModal={modalState.price}
                  toggleModalState={toggleModalState}
                />
                <CustomActionButton
                  hint="Set Bulk Depot Pricing"
                  handleOnClick={(e) => { toggleModalState('bulkPrice', true) }}
                  icon={<AccountBalanceWalletIcon />}
                  label={"Bulk Pricing"}
                />
                <BulkDepotPricingModal
                  openModal={modalState.bulkPrice}
                  toggleModalState={toggleModalState}
                />
              </>
            )}

            {(value === 0 && isAuthorizedRole(["LOGISTICS-C2"])) && (
              <>
                <CustomActionButton
                  hint="Depot Inter Tank Transfer"
                  handleOnClick={(e) => { toggleModalState('intransfer', true) }}
                  icon={<PropaneTankIcon />}
                  label={"Inter Transfer"}
                />
                <InterDepotTankTransfer
                  openModal={modalState.intransfer}
                  handleCloseModal={toggleModalState}
                />
              </>
            )}

            {(isAuthorizedRole(["CUSTOMS-L1", "SALES-C2"])) && (
              <>
                <CustomActionButton
                  hint="Add New Company"
                  handleOnClick={(e) => { toggleModalState('transporter', true) }}
                  icon={<AddCircleOutlineIcon />}
                  label={"Company"}
                />
                <TransportCompany
                  openModal={modalState.transporter}
                  handleCloseModal={() => toggleModalState('transporter', false)}
                  handleSubmitCallback={() => {
                    toggleModalState('transporter', false);
                    initialized.current = false;
                  }}
                />
              </>
            )}
            {(isAuthorizedRole(["CUSTOMS-L1"])) && (
              <>
                <CustomActionButton
                  hint="Add New Vehicle"
                  handleOnClick={(e) => { toggleModalState('vehicle', true) }}
                  icon={<AddCircleOutlineIcon />}
                  label={"Vehicle"}
                />
                <CompanyVehicle
                  transportCompanies={transportCompanies}
                  openModal={modalState.vehicle}
                  handleCloseModal={() => toggleModalState('vehicle', false)}
                  handleSubmitCallback={() => toggleModalState('vehicle', false)}
                />

                <CustomActionButton
                  hint="Add New Trailer"
                  handleOnClick={(e) => { toggleModalState('trailer', true) }}
                  icon={<AddCircleOutlineIcon />}
                  label={"Trailer"}
                />
                <CompanyTrailer
                  transportCompanies={transportCompanies}
                  openModal={modalState.trailer}
                  handleCloseModal={() => toggleModalState('trailer', false)}
                  handleSubmitCallback={() => toggleModalState('trailer', false)}
                />
                <CustomActionButton
                  hint="Add New Driver"
                  handleOnClick={(e) => { toggleModalState('driver', true) }}
                  icon={<AddCircleOutlineIcon />}
                  label={"driver"}
                />
                <CompanyDriver
                  transportCompanies={transportCompanies}
                  openModal={modalState.driver}
                  handleCloseModal={() => toggleModalState('driver', false)}
                  handleSubmitCallback={() => toggleModalState('driver', false)}
                />
              </>
            )}
            {(isAuthorizedRole(["SALES-C2"])) && (
              <>
                <CustomActionButton
                  hint="Add New Product"
                  handleOnClick={(e) => { toggleModalState('product', true) }}
                  icon={<AddCircleOutlineIcon />}
                  label={"Product"}
                />
                <NewProductLine
                  openModal={modalState.product}
                  handleCloseModal={() => toggleModalState('product', false)}
                  handleSubmitCallback={() => toggleModalState('product', false)}
                />
              </>
            )}

          </Box>
        </Box>
        < >
          <AggregatedStatsComponent
            updateStats={updateStats}
            setUpdateStats={setUpdateStats}
            isInvoices={value === 5}
          />
        </>
        <GlobalFilter onFilterChange={handleFilterChange} />

        <Box sx={{ width: '100%' }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="basic tabs example">
                {!isAuthorizedRole(["FINANCE-C2", "CUSTOMS-L1"]) && (
                  <Tab label="Orders" value={0} {...a11yProps(0)} />
                )}
                {!isAuthorizedRole(["FINANCE-C2"]) && (
                  <Tab
                    label={getApprovedTabLabel()}
                    value={1}
                    {...a11yProps(1)}
                  />
                )}
                {isAuthorizedRole(["OPERATIONS-C2", "OPERATIONS-L1", "LOGISTICS-C2", "DEMO"]) && (
                  <Tab
                    label={`${isAuthorizedRole(["LOGISTICS-C2"]) ? 'Bulk' : "Delivered"}`}
                    value={2}
                    {...a11yProps(2)}
                  />
                )}
                {isAuthorizedRole(["OPERATIONS-C2", "OPERATIONS-L1", "LOGISTICS-C2", "DEMO", "LOGISTICS-L2", "CUSTOMS-L1"]) && (
                  <Tab
                    label={`${isAuthorizedRole(["LOGISTICS-C2"]) ? ' In Take ' : "Allocated"}`}
                    value={3}
                    {...a11yProps(3)}
                  />
                )}
                {!isAuthorizedRole(["EXECUTIVE-C1", "FINANCE-C2", "CUSTOMS-L1"]) && (
                  <Tab label="Declined" value={4} {...a11yProps(4)} />
                )}
                {isAuthorizedRole(["FINANCE-C2"]) && (
                  <Tab label="Buy" value={6} {...a11yProps(6)} />
                )}
                {isAuthorizedRole(["FINANCE-C2"]) && (
                  <Tab label="Sell" value={7} {...a11yProps(7)} />
                )}
                {isAuthorizedRole(["EXECUTIVE-C1", "FINANCE-C2", "FINANCE-L1", "DEMO"]) && (
                  <Tab label="Tax Invoices" value={5} {...a11yProps(5)} />
                )}
                <Tab label="Technical Difficulties" value={9} {...a11yProps(9)} />
              </TabList>
            </Box>
            <CustomTabPanel value={0} selected={value}>
              <AllOrders filterString={getFilterString()}
                orderCategory={"all"}
                updateAllOders={updateAllOders}
                setUpdateAllOders={setUpdateAllOders}
                setUpdateStats={setUpdateStats}
                showSnackbar={showSnackbar}
              />
            </CustomTabPanel>

            <CustomTabPanel value={1} selected={value}>
              <ApprovedOrders
                filterString={getFilterString()}
                setUpdateStats={setUpdateStats}
                showSnackbar={showSnackbar}
              />
            </CustomTabPanel>

            <CustomTabPanel value={2} selected={value}>
              <DeliveredOrders
                filterString={getFilterString()}
                setUpdateStats={setUpdateStats}
                showSnackbar={showSnackbar}
              />
            </CustomTabPanel>

            <CustomTabPanel value={3} selected={value}>
              <AllocatedOrders 
                filterString={getFilterString()}
                setUpdateStats={setUpdateStats}
                transportCompanies={transportCompanies}
                showSnackbar={showSnackbar}
              />
            </CustomTabPanel>

            <CustomTabPanel value={4} selected={value}>
              <DeclinedOrders
                filterString={getFilterString()}
                setUpdateStats={setUpdateStats}
                showSnackbar={showSnackbar}
              />
            </CustomTabPanel>

            <CustomTabPanel value={5} selected={value}>
              <InvoiceList
                filterString={getFilterString()}
                setUpdateStats={setUpdateStats}
                showSnackbar={showSnackbar}
              />
            </CustomTabPanel>
            <CustomTabPanel value={6} selected={value}>
              <AllOrders filterString={getFilterString()}
                orderCategory={"buy"}
                updateAllOders={updateAllOders}
                setUpdateAllOders={setUpdateAllOders}
                setUpdateStats={setUpdateStats}
              />
            </CustomTabPanel>
            <CustomTabPanel value={7} selected={value}>
              <AllOrders filterString={getFilterString()}
                orderCategory={"sell"}
                updateAllOders={updateAllOders}
                setUpdateAllOders={setUpdateAllOders}
                setUpdateStats={setUpdateStats}
              />
            </CustomTabPanel>

            <CustomTabPanel value={8} selected={value}>
              <UnallocatedOrder filterString={getFilterString()}
                setUpdateStats={setUpdateStats}
                transportCompanies={transportCompanies}
              />
            </CustomTabPanel>

            <CustomTabPanel value={9} selected={value}>
              <TechnicalDifficulties />
            </CustomTabPanel>
          </TabContext>
        </Box>

      </Container>
    </>
  );
}
